/**
 * @copyright 2026 @ DigiNet
 * @author ANHTAI
 * @create 2026/07/13 09:15
 * @update 2026/07/13 09:15
 */

import Api from "../../../services/api";

export function loadComboTransType(params, cb) {
    return async () => {
        await Api.put('/w07f2020/load-cmb-LNV', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function loadComboWareHouse(params, cb) {
    return async () => {
        await Api.put('/w07f2020/load-cmb-WH', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function loadComboUnit(params, cb) {
    return async () => {
        await Api.put('/w07f2020/load-cmb-unitID', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function loadComboStatus(params, cb) {
    return async () => {
        await Api.put('/w07f2020/load-cmb-status', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function loadForm(params, cb) {
    return async () => {
        await Api.put('/w07f2020/load-form', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function loadVoucher(params, cb) {
    return async () => {
        await Api.put('/w07f2020/load-voucher', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function loadAttachment(params, cb) {
    return async () => {
        await Api.put('/w07f2020/load-att', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function loadDataInventory(params, cb) {
    return async () => {
        await Api.put('/w07f2020/load-cmb-Inv', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function chooseInventory(params, cb) {
    return async () => {
        await Api.put('/w07f2020/choose-inv', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function checkEdit(params, cb) {
    return async () => {
        await Api.put('/w07f2020/check-edit', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function onPrint(params, cb) {
    return async () => {
        await Api.put('/w07f2020/print', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function completeTask(params, cb) {
    return async () => {
        await Api.put('/w07f2020/complete', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function updateStatus(params, cb) {
    return async () => {
        await Api.put('/w07f2020/update-status', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function onSave(params, cb) {
    return async () => {
        await Api.post('/w07f2020/save', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function loadCmbReceiver(params, cb) {
    return async () => {
        await Api.put('/w07f2020/load-cmb-receiver', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}
